import { createFileRoute } from "@tanstack/react-router";

import { ChatListPage } from "src/pages/ChatListPage";

export const Route = createFileRoute("/_auth/chat/")({
  component: ChatListPage,
});
